export default function paramsLinker(linkId) {
  var myLink = document.getElementById(linkId);

  if (window.location.search) {
    myLink.href += window.location.search;
  }
}
